@if (sessionCheckLoading()) {
    <div class="login-page">
        <!-- Cookie-presence check in flight: avoid flicker between the two end-states -->
        <div class="session-spinner" role="status" aria-label="Checking session">
            <span class="spinner-ring"></span>
            <span class="spinner-ring"></span>
            <span class="spinner-ring"></span>
        </div>
    </div>
} @else if (showExpiredLink()) {
    <div class="login-page">
        <div class="expired-card">
            <div class="verify-icon">
                <svg width="32" height="32" viewBox="0 0 24 24">
                    <use href="assets/icons/icons-sprite.svg#mail"></use>
                </svg>
            </div>

            <h3 class="expired-title">Verification Link Expired</h3>

            <p class="expired-body">
                The verification link sent to
                @if (userEmail()) {
                    <strong>{{ userEmail() }}</strong>
                } @else {
                    your email
                }
                has expired — please request a new one to continue verifying your account.
            </p>

            <div class="timer-block">
                @if (!timerExpired()) {
                    <span class="timer-label">Time remaining</span>
                    <span class="timer-value">
                        {{ timerDisplay() }}
                    </span>
                } @else {
                    <p class="resend-expired">
                        The verification link expired. Please request a new link.
                    </p>
                }
            </div>
            <ntv-button
                size="xl"
                variant="accent"
                [disabled]="timerActive()"
                (click)="resendEmail()">
                Resend Email
            </ntv-button>
        </div>
    </div>
} @else if (showPasswordResetSuccess()) {
    <div class="login-page" data-testid="login-password-reset-success">
        <div class="status-card status-card--success">
            <div class="status-icon">
                <svg width="32" height="32" viewBox="0 0 24 24">
                    <use href="assets/icons/icons-sprite.svg#check"></use>
                </svg>
            </div>

            <h3 class="status-title">Password Reset Successful</h3>

            <p class="status-body">
                Your password has been updated. Any active sessions have been signed out for
                security. Sign in with your new password to continue.
            </p>

            <ntv-button size="xl" variant="accent" (click)="login()">Sign In</ntv-button>
        </div>
    </div>
} @else if (showLinkUsedOnce()) {
    <div class="login-page" data-testid="login-link-used-once">
        <div class="status-card status-card--warning">
            <div class="status-icon">
                <svg width="32" height="32" viewBox="0 0 12 11">
                    <use href="assets/icons/icons-sprite.svg#warning"></use>
                </svg>
            </div>

            <h3 class="status-title">Verification Link Already Used</h3>

            <p class="status-body">
                This verification link can only be used once and has already been opened. Sign in to
                continue, or request a new link if your account is not yet verified.
            </p>

            <ntv-button size="xl" variant="accent" (click)="login()">Return to Sign In</ntv-button>
        </div>
    </div>
} @else if (showAlreadyVerified()) {
    <div class="login-page" data-testid="login-already-verified">
        <div class="status-card status-card--info">
            <div class="status-icon">
                <svg width="28" height="28" viewBox="0 0 14 14">
                    <use href="assets/icons/icons-sprite.svg#info-circle"></use>
                </svg>
            </div>

            <h3 class="status-title">Account Already Verified</h3>

            <p class="status-body">
                Your email address is already confirmed. You can sign in to continue to your
                dashboard.
            </p>

            <ntv-button size="xl" variant="accent" (click)="login()">Sign In</ntv-button>
        </div>
    </div>
} @else {
    <div class="login-page">
        <div class="login-stack">
            @if (showSessionExpired()) {
                <div class="session-alert" role="alert">
                    <svg class="session-alert-icon" width="20" height="20" viewBox="0 0 14 14">
                        <use href="assets/icons/icons-sprite.svg#lock"></use>
                    </svg>
                    <div class="session-alert-text">
                        <p class="session-alert-title">Session expired</p>
                        <p class="session-alert-body">
                            Your session has ended. Please log in again to continue.
                        </p>
                    </div>
                </div>
            }

            @if (showErrorToast()) {
                <div class="session-alert" role="alert">
                    <svg class="session-alert-icon" width="20" height="20" viewBox="0 0 14 14">
                        <use href="assets/icons/icons-sprite.svg#lock"></use>
                    </svg>
                    <div class="session-alert-text">
                        <p class="session-alert-title">Authentication failed</p>
                        <p class="session-alert-body">{{ errorToastMessage() }}</p>
                    </div>
                </div>
            }

            <div class="login-card">
                <div class="login-brand">
                    <div class="login-logo">
                        <svg viewBox="0 0 2016 2000" class="w-full h-full">
                            <use href="assets/icons/icons-sprite.svg#ncompass-cursor"></use>
                        </svg>
                    </div>
                    <h1 class="login-title">N-Compass TV</h1>
                    <p class="login-subtitle">Dashboard Management Portal</p>
                </div>

                <div class="login-divider"></div>

                <div class="login-action">
                    <p class="login-prompt">Sign in with your organization account to continue.</p>
                    <button (click)="login()" class="login-btn group">
                        <svg
                            class="w-5 h-5 transition-transform duration-200 group-hover:-translate-x-0.5"
                            viewBox="0 0 24 24">
                            <use href="assets/icons/icons-sprite.svg#sign-in"></use>
                        </svg>
                        Sign in
                    </button>
                </div>

                <p class="login-footer">
                    <svg class="w-3.5 h-3.5" viewBox="0 0 24 24">
                        <use href="assets/icons/icons-sprite.svg#lock-auth0"></use>
                    </svg>
                    Secured by Auth0
                </p>
            </div>
        </div>
    </div>
}
